enum AuthErrorCodes {
    SESSION_EXPIRED = "SESSION_EXPIRED",
    INVALID_EMAIL_VERIFICATION_CODE = "INVALID_EMAIL_VERIFICATION_CODE",
    EMAIL_ALREADY_VERIFIED = "EMAIL_ALREADY_VERIFIED",
    VERIFICATION_EMAIL_COULD_NOT_BE_RESENT = "VERIFICATION_EMAIL_COULD_NOT_BE_RESENT",
    TOKEN_EXPIRED = "TOKEN_EXPIRED",
    INVALID_CREDENTIALS = "INVALID_CREDENTIALS", // skipcq: SCT-A000
    PASSWORD_ALREADY_USED = "PASSWORD_ALREADY_USED",
    USER_NOT_VERIFIED = "USER_NOT_VERIFIED",
    RECOVER_PASSWORD_ERROR = "RECOVER_PASSWORD_ERROR",
    RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR",
    INVALID_PASSWORD_CODE = "INVALID_PASSWORD_CODE",
    INVALID_PASSWORD = "INVALID_PASSWORD",
    BLOCKED_USER = "BLOCKED_USER",
    TOKEN_NOT_FOUND = "TOKEN_NOT_FOUND",
    TOKEN_ALREADY_VERIFIED = "TOKEN_ALREADY_VERIFIED",
    EMAIL_NOT_VERIFIED = "EMAIL_NOT_VERIFIED",
    INVALID_EMAIL_ADDRESS = "INVALID_EMAIL_ADDRESS",
    USER_NOT_FOUND = "USER_NOT_FOUND",
    CHANGE_PASSWORD = "CHANGE_PASSWORD",
    USER_NOT_MIGRATED_TO_COGNITO = "USER_NOT_MIGRATED_TO_COGNITO",
}

export default AuthErrorCodes;
